//
// Based on React example "Dropdown Menu (including submenus)" in https://floating-ui.com/docs/react-examples.
// https://codesandbox.io/s/admiring-lamport-5wt3yg?file=/src/DropdownMenu.tsx
//

import { FloatingTree } from '@floating-ui/react';
import React, { useEffect } from 'react';

import { nameof } from '../../utils/nameof';
import { RootMenu } from './components/root-menu';

type Props = {
  top: number;
  left: number;
  children: React.ReactNode;
  onClose?: () => void;
};

const ContextMenu = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  // Prevents default contextmenu from showing when custom context menu is shown.
  useEffect(() => {
    const handleContextMenu = (event: MouseEvent) => {
      event.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  return (
    <FloatingTree>
      <RootMenu {...props} onClose={() => props.onClose?.()} />
    </FloatingTree>
  );
});

ContextMenu.displayName = nameof({ ContextMenu });

export { ContextMenu };
